<template>
  <el-form ref="formRef" :model="formData" :rules="rules" label-width="120px" @submit.native.prevent>
    <el-form-item label="维度" prop="dimension">
        <ESelect v-model="formData.dimension" @change="()=>getDisableDate()">
            <el-option 
                v-for="item in dimensionList"
                :key="item.name"
                :label="item.display_name"
                :value="item.name"
            />
        </ESelect>
    </el-form-item>
    <el-form-item :label="dateLabel" prop="range_time">
        <el-date-picker
            v-model="formData.range_time"
            :disabled="loading"
            type="daterange"
            :clearable="false"
            value-format="yyyy-MM-dd"
            style="width: 310px;"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
        />
    </el-form-item>
  </el-form>
</template>

<script>
import dayjs from 'dayjs';
import { DIMENSION_TYPE_DATA_LIST } from '../../constant'
export default {
    props: [ 'dateLabel', 'defaultData', 'dimension', 'loading' ],
    name: 'DateType',
    data() {
        const { range_time, dimension } = this.defaultData || {};
         const _this = this;
        return {
            formData: {
                range_time: range_time || [],
                dimension: dimension || ''
            },
            rules: {
                range_time: [
                    { required: true, message: '请选择日期', trigger: 'blur' },
                ],
                dimension: [
					{ required: true, message: '请选择维度', trigger: 'blur' }
				]
            },
            dateData: {},
            pickerOptions: {
                firstDayOfWeek: 1,
                disabledDate(time) {
                    // 所选筛选条件在该日期无任何数据
                    return _this.isDisabledDate(time)
                },
            }
        }
    },
    computed: {
        dimensionList() {
			return DIMENSION_TYPE_DATA_LIST[this.dimension.name] || []
		},
        disabledDateData() {
            return (this.dateData.has_cost_date || []).reduce((pre, item)=> {
                pre[this.formatDate(item)] = true;
                return pre;
            }, {})
        }
    },
    mounted() {
        this.getDisableDate()
    },
    methods: {
        getDisableDate() {
            this.$emit('disable-date', (dateData)=> {
                this.dateData = dateData;
            }, { return_condition: `${this.dimension.name}|${this.formData.dimension}` })
        },
        isDisabledDate(time) {
            time = this.formatDate(time);
            // const { end_date, all_disabled, start_date, has_cost_date } = this.dateData;
            // 大于今日
            if (new Date(time).getTime() > new Date().getTime()) {
                return true;
            };
            // 小于起始日期
            const startDate = this.dateData.start_date;
            if (startDate && new Date(time).getTime() < new Date(this.formatDate(startDate) ).getTime()) {
               return true
            };
            if (!this.disabledDateData[time]) {
                return true;
            }
            return false
        },
        // 格式化日期
        formatDate(date) {
            return dayjs(date).format('YYYY-MM-DD')
        },
        async getFormData() {
            const valid = await this.$refs['formRef'].validate();
            if (valid) {
                return {
                    ...this.formData
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>

</style>